export default "__VITE_ASSET__B428LE9g__"